import React, { Component } from "react"
import { graphql } from "gatsby"
import "../components/layout.css"
import { startBTL } from "../btl"

export const query = graphql`
  {
    allDataJson {
      edges {
        node {
          title
          primary_color
          business_id
          fontFamily
          fontVariants
        }
      }
    }
  }
`

export default class index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: this.props.data,
      favoriteLocation: {},
      businessId: this.props.data.allDataJson.edges[0].node.business_id
        ? this.props.data.allDataJson.edges[0].node.business_id
        : "",
      envCode: "local",
    }
  }
  componentDidMount() {
    startBTL({
      businessId: this.state.businessId,
    })

    let envCode = window
      ? window.location.pathname.indexOf("/staging") > -1
        ? "staging"
        : window && window.location.pathname.indexOf("/prod") > -1
        ? "prod"
        : "local"
      : ""
    this.setState({ envCode: envCode })

    console.log(
      "fontFamily",
      this.props.data.allDataJson.edges[0].node.fontFamily,
      this.props.data.allDataJson.edges[0].node.fontVariants
    )
    //     <link rel="preconnect" href="https://fonts.googleapis.com">
    // <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin></link>

    let apiLinkElement = document.createElement("link")
    apiLinkElement.rel = "preconnect"
    apiLinkElement.href = "https://fonts.googleapis.com"
    let gstaticLinkElement = document.createElement("link")
    gstaticLinkElement.rel = "preconnect"
    gstaticLinkElement.href = "https://fonts.gstatic.com"
    gstaticLinkElement.crossOrigin = true
    document.head.appendChild(gstaticLinkElement)
    document.head.appendChild(apiLinkElement)
    let fontFamily = this.props.data.allDataJson.edges[0].node.fontFamily
    let fontVaraints = this.props.data.allDataJson.edges[0].node.fontVariants

    if (fontFamily && fontVaraints) {
      let linkElement = document.createElement("link")
      // linkElement.type = "type/css"
      linkElement.rel = "stylesheet"

      document.head.appendChild(linkElement)
      linkElement.href = generateGoogleFontsUrl(fontFamily, fontVaraints)

      document.documentElement.style.setProperty("--gz-font-family", fontFamily)
    }

    function generateGoogleFontsUrl(fontFamily, variants = []) {
      // Encode the font family name for URL
      const encodedFontFamily = encodeURIComponent(
        fontFamily.replace(/ /g, "+")
      )

      // Join the variants with commas
      let variantString = ""
      let variantTuples = []
      variants.map(v => {
        if (v.includes("italic")) {
          variantTuples.push([
            1,
            v.replace("italic", "") == "" ? "400" : v.replace("italic", ""),
          ])
        } else if (v.includes("regular")) {
          variantTuples.push([0, "400"])
        } else {
          variantTuples.push([0, v])
          // variantString = variantString + `0,${v};`
        }
      })

      variantTuples.sort((a, b) => a[0] - b[0])

      variantTuples.map((v, i) => {
        variantString =
          variantString +
          v.join(",") +
          (variantTuples.length - 1 !== i ? ";" : "")
      })

      // Construct the Google Fonts URL
      const url = `https://fonts.googleapis.com/css2?family=${encodedFontFamily}:ital,wght@${variantString}&display=swap`
      console.log("urls", url, variantTuples)
      return url
    }
  }

  render() {
    return (
      <>
        <div
          className="privacy_container"
          data-pz="privacy-page"
          data-pz-purpose="privacy-policy" data-pz-category="footer"
          style={{
            backgroundColor: this.state.data.allDataJson.edges[0].node
              .primary_color,
          }}
        >
          <header
            className="header_main"
            style={{
              backgroundColor: this.state.data.allDataJson.edges[0].node
                .primary_color,
            }}
          >
            {/* <a href="https://growthzilla.com">
              <img
                className="privacy_image"
                src={"https://growthzilla.com/img/growthzilla-logo.png"}
                alt=""
              ></img>
            </a> */}
            <div className="privacy_image"></div>
          </header>
          <div className="privacy_main">
            <h2>Privacy Policy</h2>{" "}
            <p>
              {this.state.data.allDataJson.edges[0].node.title ||
                "Growthzilla Inc."}{" "}
              is committed to protecting your privacy. In this policy, the terms
              "we", "us", "our", or "ours" refer to{" "}
              {this.state.data.allDataJson.edges[0].node.title ||
                "Growthzilla Inc."}
              , and the terms "you", "your", or "yours" refer to you as the data
              subject who uses our app.
            </p>
            <h4>What information do we collect?</h4>
            <p>
              We collect information from you when you download and use our app.
              We collect data about how users interact with our app. This
              includes access dates and times, pages viewed, device type, IP
              addresses, operating systems and versions, and other system
              activity.
              <br />
              <br />
              When you book an appointment through our app, you will be prompted
              to add personal information such as your name, email address, and
              phone number that we store in our system for managing service
              delivery. We also collect appointment details like services
              booked, time slots, etc.
              <br />
              <br />
              You may also be requested to share background and foreground
              location sharing permissions. You will still be able to use the
              app, except for certain features that rely on location data, even
              when such permission is not granted.
            </p>
            <h4>What do we use your information for?</h4>
            <ul>
              <li>
                To personalize your experience - your information helps us to
                better tailor our services to your individual needs.
              </li>
              <li>
                To improve our apps - we continually strive to improve our app
                offerings based on the information and feedback we receive from
                you.
              </li>
              <li>
                To improve customer service - your information helps us respond
                to your customer service requests and support needs.
              </li>
              <li>
                To process transactions and account maintenance– we need your
                information to process payment transactions and maintain your
                account with us. Your information, whether public or private,
                will not be sold, exchanged, transferred, or given to any other
                company without your consent, except (a) for the express purpose
                of delivering the purchased product or service requested and (b)
                as part of the change in business ownership.
              </li>
              <li>To detect and prevent fraudulent and security incidents.</li>
              <li>
                To administer contests, promotions, surveys or other similar app
                features.
              </li>
              <li>
                To send you periodic emails, text messages, and app
                notifications about our products and services. The email address
                you provide for appointment booking may be used to send you
                information and updates pertaining to your appointment as well
                as to send offers, discounts, etc.
              </li>
            </ul>
            <h4>How do we protect your information?</h4>
            <p>
              We implement a variety of security measures to maintain the safety
              of your personal information when you enter, submit, or access
              your personal information. We offer the use of a secure server.
              All supplied sensitive/credit information is transmitted via
              Secure Socket Layer (SSL) technology and then encrypted into our
              Payment gateway providers database only to be accessible by those
              authorized with special access rights to such systems, and are
              required to keep the information confidential. After a
              transaction, your private information (credit cards, social
              security numbers, financials, etc.) will not be stored on our
              servers.
            </p>
            <h4>Opting-out From Messaging</h4>
            <p>
              We respect your communication preference and provide you with easy
              opt-out options if at any time you would like to unsubscribe from
              receiving future emails, texts, or app notifications.
              <ul>
                <li>
                  You can reply “Stop” to any text message we send to stop
                  receiving automated promotional text messages. You will
                  continue to receive transactional text messages like
                  appointment confirmations, reminders, and receipts.
                </li>
                <li>
                  You can unsubscribe from receiving promotional email messages
                  by clicking on the “Unsubscribe” links on the emails you
                  receive from us. You will continue to receive transactional
                  emails like appointment confirmations, reminders, and
                  receipts.
                </li>
                <li>
                  You can disable app notifications from account section of the
                  app.
                </li>
              </ul>
            </p>
            <h4>Account Creation and Deletion</h4>
            <p>
              <span style={{ fontWeight: "bold", color: "black" }}>
                Account Creation:
              </span>{" "}
              An account may be established when you book an appointment, buy a
              product or service, check-in at the salon, register for promotions
              or discounts, buy gift cards, become a member, or are referred by
              your someone.
            </p>
            <p>
              <span style={{ fontWeight: "bold", color: "black" }}>
                Account Deletion:
              </span>{" "}
              You may delete your account at any time by contacting the salon
              and requesting that your account be deleted. Upon receiving your
              request, we will delete your account and all associated personal
              information within a reasonable timeframe, unless retention of
              such information is necessary for legal or legitimate business
              purposes. Please note that deleting your account may impact your
              ability to access certain features or services provided by our
              app.
            </p>
            <h4>Do we collect location data?</h4>
            <p>
              We may request location-sharing permission and if permitted we
              collect location data in the mobile apps. Location data is used
              strictly for enhancing the features of the app, improving user
              experience, and planning business operations. Users can approve or
              deny the request for location permission. The app can collect
              location data only if the location permission request is approved
              and the location-based features will be enabled in the app. Some
              features like finding the nearest location require foreground
              permission, while some features like automatic check-in upon
              arrival at the business require background permission. Background
              permission allows the app to collect location data even when the
              app is not in use. If you deny location data permission, such
              features will be disabled. You will still be able to access other
              features of the app that do not depend on location data.
            </p>
            <h4>Arrival Check-in Using Background Location Permission</h4>
            <p>
              The background location is used for the Arrival Check-In feature
              in our app. Arrival Check-In feature automatically checks in users
              to their appointment when they arrive at the business location
              without having to launch the app.
            </p>
            <h4>Do we use cookies?</h4>
            <p>
              Yes, we use cookies to help us remember and process the items in
              your shopping cart, understand and save your preferences for
              future visits and compile aggregate data about app traffic and app
              interaction so that we can offer better app experiences and tools
              in the future. We may contract with third-party service providers
              to assist us in better understanding our app visitors. These
              service providers are not permitted to use the information
              collected on our behalf except to help us conduct and improve our
              business.
            </p>
            <h4>Do we disclose any information to outside parties?</h4>
            <p>
              We do not sell, trade, or otherwise transfer to outside parties
              your personally identifiable information. This does not include
              trusted third parties who assist us in operating our app,
              conducting our business, or servicing you, so long as those
              parties agree to keep this information confidential. We may also
              release your information when we believe release is appropriate to
              comply with the law, enforce our app policies, or protect our or
              others' rights, property, or safety. However, non-personally
              identifiable visitor information may be provided to other parties
              for marketing, advertising, or other uses.
            </p>
            <h4>Third party links</h4>
            <p>
              We value your privacy and we take the necessary precautions to
              protect it. Occasionally, with discretion, we may include or offer
              third-party products or services on our app or promote them. These
              third-party sites have separate and independent privacy policies
              and any information with them will be subject to their policies.
            </p>
            <h4>Children's Online Privacy Protection Act Compliance</h4>
            <p>
              Our app is targeted to users who are at least 13 years old and are
              in compliance with the requirements of COPPA (Children's Online
              Privacy Protection Act) as we do not collect any information from
              anyone under 13 years of age.
            </p>
            <h4>Online Privacy Policy Only</h4>
            <p>
              This online privacy policy applies only to information collected
              through our app and not to information collected offline.
            </p>
            {/* <h4>Terms and Conditions</h4> */}
            {/* <p>
              Please also visit our Terms and Conditions section establishing
              the use, disclaimers, and limitations of liability governing the
              use of our website at{" "}
              <a href="https://www.growthzilla.com/tos">
                https://www.growthzilla.com/tos
              </a>
            </p> */}
            <h4>Your Consent</h4>
            <p>By using our app, you consent to our online privacy policy.</p>
            <h4>Changes to our Privacy Policy</h4>
            <p>
              If we decide to change our privacy policy, we will update the
              Privacy Policy modification date below.
              <br /> This policy was last modified on 07/28/2023.
              <br /> If you have any queries regarding privacy policy. Please
              fill up the form in the link below:
              <br />
              <a
                data-pz-element="privacy-contact-us"
                data-pz-signal="conversion"
                href={`https://privacy.uzeli.com/${this.state.businessId}/${this.state.envCode}/contactus`}
                target="_blank"
                rel="noreferrer"
              >
                {`https://privacy.uzeli.com/${this.state.businessId}/${this.state.envCode}/contactus`}
              </a>
            </p>
          </div>
        </div>
      </>
    )
  }
}
